/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateRule.defs.js'
export { main as default } from './updateRule.defs.js'
